import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export const ChipHour = styled(Chip)(() => () => ({
  padding: '12px 16px 12px 16px',
  '.MuiChip-label': {
    padding: '0px'
  },
  '&.hidden': {
    display: 'none'
  }
}));

export const ChipList = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start'
}));

export const ChilHourLabel = styled(Typography)(() => ({
  marginBottom: '10px'
}));
